export default `
    id
    title
    rating
    release
    criticRating
    timeToBeat
    description
    youTubeId
`;
